import { render, staticRenderFns } from "./AccountMailboxesView.vue?vue&type=template&id=0ccee569&"
import script from "./AccountMailboxesView.vue?vue&type=script&lang=js&"
export * from "./AccountMailboxesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ccee569')) {
      api.createRecord('0ccee569', component.options)
    } else {
      api.reload('0ccee569', component.options)
    }
    module.hot.accept("./AccountMailboxesView.vue?vue&type=template&id=0ccee569&", function () {
      api.rerender('0ccee569', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/email/account/AccountMailboxesView.vue"
export default component.exports